module.exports = __webpack_public_path__ + "static/media/tutoring-clarinet.2b50ce6a.png";